import { render, staticRenderFns } from "./modalLg.vue?vue&type=template&id=0d796510&"
import script from "./modalLg.vue?vue&type=script&lang=js&"
export * from "./modalLg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports